<template>
  <qx-card title="车辆列表">
    <LogRightDialog ref="logRightDialog" busiCode="100003" auditCode="100005" />
    <UploadDriverCardDialog
      ref="uploadDriverCardDialog"
      bizCodes="imp1000112"
      @sub="getData"
    />

    <section slot="titleRight">
      <qx-permpisions permpisions="1002030209">
        <el-button
          type="primary"
          plain
          @click="() => showBatchUploadLicenseDialog()"
        >
          <i class="iconfont">&#xe6ad;</i>行驶证批量上传
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="1002030205">
        <ImportBtn
          title="外调车档案导入"
          bizCodes="imp1000121"
          fileUrl="/file/外调车档案导入模板.xlsx"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1002030206">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="vehicleDataInfoBO.ajax?cmd=doQueryVehicleAll"
          :params="fullSearchData"
          bizName="外调车档案信息导出"
          bizCode="exp100091"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1002030201">
        <el-button type="primary" plain @click="() => toEdit({})">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'plateNumber'"
                  @click="toCarDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section
                  v-else-if="scope.column.property === 'mobilePhone'"
                  @click="toDriverDetail(scope.row, '')"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section v-else-if="scope.column.property === 'tenantName'">
                  <span
                    v-if="
                      scope.row.tenantName === '' ||
                      scope.row.tenantName === '平台合作车'
                    "
                    >{{
                      scope.row.tenantName ? scope.row.tenantName : '-'
                    }}</span
                  >
                  <span
                    class="primary cur"
                    v-if="
                      scope.row.tenantName !== '' &&
                      scope.row.tenantName !== '平台合作车'
                    "
                    @click="toTenantDetail(scope.row)"
                    >{{ scope.row.tenantName }}</span
                  >
                </section>
                <section
                  v-else-if="scope.column.property === 'cooperationCount'"
                  @click="toConveyDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section v-else>
                  <span>{{ scope.row[scope.column.property] }}</span>
                </section>
              </section>
            </el-table-column>
          </template>
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="140"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    showCondition: scope.row.isAuth == 1,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve', '审核车辆'),
                  },
                  {
                    permpisions: '1002030202',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    permpisions: '1002030208',
                    showCondition: scope.row.vehicleState === 1,
                    name: '闲置',
                    event: () => toIdle(scope.row, 0),
                  },
                  {
                    permpisions: '1002030207',
                    showCondition: scope.row.vehicleState !== 1,
                    name: '启用',
                    event: () => toIdle(scope.row, 1),
                  },
                  {
                    permpisions: '1002030203',
                    showCondition: true,
                    name: '删除',
                    event: () => del(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.relId),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import UploadDriverCardDialog from 'components/uploadDriverCardDialog';
import ImportBtn from 'components/importBtn';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  doQueryVehicleAll,
  updateVehicleState,
  doRemoveVehicle,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ImportBtn,
    ExportBtn,
    LogRightDialog,
    UploadDriverCardDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { label: '车牌号码', prop: 'plateNumber', fixed: true },
          { label: '司机姓名', prop: 'linkman' },
          { label: '司机手机', prop: 'mobilePhone' },
          { label: '牌照类型', prop: 'licenceTypeName' },
          { label: '归属车队', prop: 'tenantName' },
          { label: '车队手机', prop: 'linkPhone' },
          { label: '合作车队', prop: 'cooperationCount' },
          { label: '定位类型', prop: 'locationServName' },
          { label: '生效时间', prop: 'beiDouSerivceDate' },
          { label: 'ETC卡号', prop: 'etcCardNo' },
          { label: '待审核状态', prop: 'authStateName' },
          { label: '使用状态', prop: 'vehicleStateName' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryVehicleAll,
    showBatchUploadLicenseDialog () { // 批量上传行驶证
      this.$refs.uploadDriverCardDialog.show();
    },
    toEdit (item) {

      /**
       * 下面这个页面除了【车辆管理-我的车辆】的新增和修改之外，还有一个入口是外调车辆的新增和修改，
       * 因为有一部分逻辑因为不同的入口进去处理逻辑不一样，所以添加一个 type 值来帮助区分判断，
       * 这里设置了 type = my 代表从【我的车辆】进去的，type = outward 代表从【外调车辆】进去的
       */
      // this.$message({
      //   type: 'info',
      //   message: '开发中',
      // });
      const query = `id=${item.vehicleCode || ''}&vehicleClass=${item.vehicleClass || ''}&type=outward`;
      this.jump({
        label: (item.vehicleCode ? '修改' : '新增') + '外调车辆',
        url: `/manage/car/archives/edit?${query}`,
        full: true,
      });
    },
    toTenantDetail (item) {
      this.jump({
        label: '车队详情',
        url: `/manage/other/fleet/base?id=${item.tenantId}`,
        full: true,
      });
    },
    toCarDetail (item) {
      const type = 'detail';
      this.jump({
        label: `查看车辆-${item.plateNumber}`,
        url: `/manage/car/archives/my/detailRecord?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass}&type=${type}`,
        full: true,
      });
    },
    toDriverDetail (item, type) {
      this.jump({
        label: '查看司机档案',
        url: `/manage/archives/driver/archives/detail?id=${item.driverUserId}&type=${type}`,
        full: true,
      });
    },
    toConveyDetail (item) {
      this.jump({
        label: `合作车队详情-${item.plateNumber}`,
        url: `/manage/car/archives/my/cooperationMotorcade?id=${item.vehicleCode}`,
        full: true,
      });
    },
    async toIdle (item, vehicleState) {
      const confirmRes = await this.$confirm(`确认${vehicleState ? '启用' : '停用'}车牌号【${item.plateNumber}】吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await updateVehicleState({
          vehicleCode: item.vehicleCode,
          vehicleState,
        });
        this.getData();
      }
    },
    toDetail (item, type = '', label = '') {
      this.jump({
        label,
        url: `/manage/car/archives/my/detail?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass}&relId=${item.relId}&type=${type}`,
        full: true,
      });
    },
    async del (item) {
      const confirmRes = await this.$confirm(`确认移除车牌号【${item.plateNumber}】的车辆？移除后您将无法使用该车辆，可在历史档案中查询车辆信息。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await doRemoveVehicle({ vehicleCode: item.vehicleCode });
        this.getData();
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
